import { useState } from 'react'

const isLocalhost = () => [ 'localhost', '127.0.0.1' ].includes(window.location.hostname)

interface UseAdminModeReturn {
    available: boolean
    adminMode: boolean
    toggleAdminMode: () => void
}

/**
 * Le mode admin (édition du référentiel BDREF3) n'est accessible qu'en local : ce n'est pas une
 * fonctionnalité qu'on expose aux utilisateurs en production, quel que soit leur compte.
 */
const useAdminMode = (): UseAdminModeReturn => {
    const [ adminMode, setAdminMode ] = useState<boolean>(false)
    const available = isLocalhost()

    return {
        available,
        adminMode: available && adminMode,
        toggleAdminMode: () => setAdminMode(prev => !prev),
    }
}

export default useAdminMode
